export default __webpack_public_path__ + "static/media/instagram-icon.0797662d.svg";